import { API } from 'aws-amplify';
var serviceNames = require('../ServiceNameMapper');
const Buffer = require('buffer').Buffer;

export async function getConfig() {
    console.log("MenuBar: getConfig");

    try {
        let apiName = serviceNames.getWebsiteService();
        let path = ""; //replace this with the path you have configured on your API
        let myInit = {
            body: {
                code: global.$code,
                command: "getWebConfig",
                bucket: global.$s3bucket,
            },
            response: true,
            convertEmptyValues: true,
            headers: {},
        };

        const response = await API.post(apiName, path, myInit);
        
        if (response.err == null && response.data != null) {
            let buf = Buffer.from(response.data.Body);

            var arr = JSON.parse(buf.toString());
            
            global.$config = arr;
            global.$menuItems = arr["header"].menus;
            global.$header = arr["header"];
            global.$home = arr["home"];
            global.$footer = arr["footer"];
            global.$login = arr["login"];
            global.$schedule = arr["schedule"];
            global.$posters = arr["posters"];
            global.$session = arr["session"];
            global.$settings = arr["settings"];
            global.$sponsors = arr["sponsors"];
            global.$exhibitors = arr["exhibitors"];
            global.$speakers = arr["speakers"];
            global.$contact = arr["contact"];
            global.$registration = arr["registration"];
            global.$login = arr["login"];
            global.$profile = arr["profile"];
            global.$scrolltotop = arr["scrolltotop"];
            global.$numberofdays = arr["schedule"].numberofdays;
            global.$numberofposterdays = arr["posters"].numberofdays;
            global.$attendees = arr["attendees"];
            global.$auctions = arr["auctions"];
            global.$chat = arr["chat"];
            global.$conversations = arr["conversations"];
            global.$virtualexpo = arr["virtualexpo"];
            if (arr["registrationform"] == null) {
                global.$registrationform = "null";
            } else {
                global.$registrationform = arr["registrationform"];
            }
            if (arr["messages"] == null) {
                global.$messages = "null";
            } else {
                global.$messages = arr["messages"];
            }
            if (arr["appointments"] == null) {
                global.$appointments = "null";
            } else {
                global.$appointments = arr["appointments"];
            }

            if (arr["speakers2"] == null) {
                global.$speakers2 = "null";
            } else {
                global.$speakers2 = arr["speakers2"];
            }

            if (arr["points"] == null) {
                global.$points = "null";
            } else {
                global.$points = arr["points"];
            }


            if (arr["header"].menutextcolor == null) {
                global.menutextcolor = "white";
            } else {
                global.menutextcolor = arr["header"].menutextcolor;
            }

            if (arr["home"].sponsors.layout == null) {
                global.$homesponsorslayout = "horizantal";
            } else {
                global.$homesponsorslayout = arr["home"].sponsors.layout;
            }



            if (arr["home"].styles.profileicon == null) {
                global.profileiconstyles = {
                    paddingRight: "10px",
                    fontSize: "25px",
                    color: "white",
                };
            } else {
                global.profileiconstyles = arr["home"].styles.profileicon;
            }


            if (arr["header"].menu.dropdown1 == null) {
                global.$dropdown1 = "";
                global.dropdown1login = "N";
            } else {
                global.$dropdown1 = arr["header"].menu.dropdown1;
                global.dropdown1login = arr["header"].menu.dropdown1.login;
            }


            if (arr["header"].menu.dropdown2 == null) {
                global.$dropdown2 = "";
                global.dropdown2login = "N";
            } else {
                global.$dropdown2 = arr["header"].menu.dropdown2;
                global.dropdown2login = arr["header"].menu.dropdown2.login;
            }

            if (arr["header"].menu.dropdown3 == null) {
                global.$dropdown3 = "";
                global.dropdown3login = "N";
            } else {
                global.$dropdown3 = arr["header"].menu.dropdown3;
                global.dropdown3login = arr["header"].menu.dropdown3.login;
            }



            if (arr["header"].menu.dropdown4 == null) {
                global.$dropdown4 = "";
                global.dropdown4login = "N";
            } else {
                global.$dropdown4 = arr["header"].menu.dropdown4;
                global.dropdown4login = arr["header"].menu.dropdown4.login;
            }

            if (arr["header"].menu.dropdown5 == null) {
                global.$dropdown5 = "";
                global.dropdown5login = "N";
            } else {
                global.$dropdown5 = arr["header"].menu.dropdown5;
            }




            global.$activeScheduleTab = global.$schedule.day1text;

            if (arr["schedule"].numberofdays == "1") {
                global.$scheduleday1 = arr["schedule"].day1;
                global.$stag1 = arr["schedule"].stag1;
                global.$day1text = arr["schedule"].day1text;
            }
            if (arr["schedule"].numberofdays == "2") {
                global.$scheduleday1 = arr["schedule"].day1;
                global.$scheduleday2 = arr["schedule"].day2;
                global.$stag1 = arr["schedule"].stag1;
                global.$stag2 = arr["schedule"].stag2;
                global.$day1text = arr["schedule"].day1text;
                global.$day2text = arr["schedule"].day2text;
            }
            if (arr["schedule"].numberofdays == "3") {
                global.$scheduleday1 = arr["schedule"].day1;
                global.$scheduleday2 = arr["schedule"].day2;
                global.$scheduleday3 = arr["schedule"].day3;
                global.$stag1 = arr["schedule"].stag1;
                global.$stag2 = arr["schedule"].stag2;
                global.$stag3 = arr["schedule"].stag3;
                global.$day1text = arr["schedule"].day1text;
                global.$day2text = arr["schedule"].day2text;
                global.$day3text = arr["schedule"].day3text;
            }

            if (arr["posters"].numberofdays == "1") {
                global.$posterstag1 = arr["posters"].stag1;
                global.$posterday1text = arr["posters"].day1text;
            }

            if (arr["posters"].numberofdays == "2") {
                global.$posterstag1 = arr["posters"].stag1;
                global.$posterstag2 = arr["posters"].stag2;
                global.$posterday1text = arr["posters"].day1text;
                global.$posterday2text = arr["posters"].day2text;
            }
            if (arr["posters"].numberofdays == "3") {
                global.$posterstag1 = arr["posters"].stag1;
                global.$posterstag2 = arr["posters"].stag2;
                global.$posterstag3 = arr["posters"].stag3;
                global.$posterday1text = arr["posters"].day1text;
                global.$posterday2text = arr["posters"].day2text;
                global.$posterday3text = arr["posters"].day3text;
            }

            global.$sponsorscrollonsessiondetails =
                arr["session"].sponsorscrollonsessiondetails;
            global.$closedvideo = arr["session"].closedvideo;
            global.$schedulebanner = arr["schedule"].banner;
            global.$poolid = global.$settings.poolids.userpoolid;
            global.$clientid = global.$settings.poolids.userpoolwebclientid;

            return true;
        }
        else {
            return false;
        }

    } catch (error) {
        console.log(error);
    }


}

export function clearGlobalVariables() {
    global.$loginstatus = "false";
    global.$loggedinexhibitor = null
    global.$loginid = null
    global.$password = null
    global.$variables = null
    global.$selectedregoptions = null;
    global.$registereditems = null;
    global.$totalregitems = null;
    global.$attendeeregitems = null;
    global.$guestregitems = null;
    global.$regItemsForSignupCount = null;

    global.$deferredpromo = null;
    global.$deferredpromoamount = null;
    global.$regamount = null;
    global.$finalamount = null;

    global.$hideregisterbutton = null;
    global.$selectedPaymentOption = null;
    global.$regdiscountinfo = null;
    global.$regattendeestatus = null;
    global.$reggueststatus = null;
    global.$regemail = null;
    global.$reguestemail = null;
    global.$regattendeeinfo = null;
    global.$regguestinfo = null;
    global.$loggedinguest = null;
    global.$guestexist = null;
    global.$terms1status = null;
    global.$terms2status = null;
    global.$terms3status = null;
    global.$paymentid = null;
    global.$upgradepricediff = null;

    global.$regitemtoreducecount = null;
    global.$isattendeeregistered = null;
    global.$isguestregistered = null;
    global.$transactionfee = null;
    global.$openpaymentpopup = false; // this will cntrols payment popup
    global.$attendeeDetails = null
    global.$loggedinuser = null
    global.$regloginstatus = null
    global.$regitemsjson = null
    global.$loggedinuserregitems = null
    global.$fname = null;
    global.$lname = null;
    global.$email = null;
    global.$userid = null;
    global.$company = null;
    global.$phone = null;
    global.$title = null;
    global.$regid = null;
    global.$memberid = null;
    global.$attendeetype = null;
    global.$userstype = null;
    global.$regstatus = null;
    global.$attendeeguests = null;
    global.$loggedinuserregitems = null;
    global.$regitemsjson = null;
    global.$loggedinuser = null;
    global.$companyid = null
  }